import { useTranslation } from "react-i18next";
import Heading from "@vfuk/core-heading";
import Paragraph from "@vfuk/core-paragraph/";
import Banner from "./Banner";
import manageAccessBanner from "@img/manageAccessBanner.png";
import { Stack } from "@ucchub/ui";
import Icon from "@vfuk/core-icon";
import Pill from "@vfuk/core-pill";
import type { PillProps } from "@vfuk/core-pill";
import Spacing from "@vfuk/core-spacing";
import { CustomerDetails, OrganisationStatus } from "./Customer.types";
import { STATUS_TRANSLATE_KEYS } from "./CustomerDetails";

type Props = {
  headText: string;
  pid?: string;
  status?: CustomerDetails["status"];
};

const STATUS_STATE: { [k in CustomerDetails["status"]]: PillProps["state"] } = {
  [OrganisationStatus.ACTIVE]: "success",
  [OrganisationStatus.DRAFT]: "warn",
  [OrganisationStatus.INACTIVE]: undefined,
};

const CustomerBanner = ({ headText, pid, status }: Props) => {
  const { t } = useTranslation();
  const statusState = status && STATUS_STATE[status];
  return (
    <Banner backgroundImage={manageAccessBanner}>
      <Stack direction="column" rowGap="0.6rem" align="start">
        <Stack columnGap="0.5rem">
          <Icon size={4} name="users" />
          <Heading level={4} weight={2} noMargin text={headText} inverse />
          {status && (
            <Pill
              text={t(`core:customers:${STATUS_TRANSLATE_KEYS[status]}`)}
              appearance="alt3"
              state={statusState}
            />
          )}
        </Stack>
        <Spacing
          spacingLevel={{
            left: 7,
          }}
        >
          <Paragraph size={1} inverse>
            {pid &&
              t("core:customers:pid_code", {
                pid: pid,
              })}
          </Paragraph>
        </Spacing>
      </Stack>
    </Banner>
  );
};

export default CustomerBanner;
